import React from 'react';
import { view } from 'react-easy-state';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';


const PrestSceltaRicetta = ({ prestazione, onClick, t }) => {
  const icClasses = classNames({
    button: true,
    small: true,
    selected: prestazione.get('impTipo') === 'IC'
  });

  const reClasses = classNames({
    button: true,
    small: true,
    selected: prestazione.get('impTipo') === 'RE'
  });

  return (
    <div className="kfpr-row kfpr-row-btn">
      <button name="impTipo" value={"IC"} className={icClasses} onClick={onClick}>
        {t("Impegnativa cartacea")}
      </button>
      <button name="impTipo" value={"RE"} className={reClasses} onClick={onClick}>
        {t("Ricetta elettronica")}
      </button>                                            
    </div>
  )
}

export default withTranslation()(view(PrestSceltaRicetta));






